module.exports = __webpack_public_path__ + "static/img/vnd-dgn.313f9f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/vnd-dgn.png
// module id = 5ad3
// module chunks = 53